import * as React from "react";
import { connect } from "react-redux";

import { Wrapper } from "../../../components";
import { MetaTags } from "../../../head";
import http from "../../../helpers/http";
import { RootState, Dispatch } from "../../../store/types";
import { selectors as authSelectors, actions as authActions } from "../../Auth";
import { history } from "../../../store";

import AccountModal from "./AccountModal";
import Login from "./Login";
import { LoginFormValues } from "./LoginForm";
import { SubmissionError } from "redux-form";

export interface LoginContainerState {
  isError: boolean;
  formMsg?: string;
  isShowingModal: boolean;
}

export interface LoginContainerProps {
  formMsg: string;
  isLoggedIn: boolean;
  saveLoginToken: (token: string) => void;
}

class LoginContainer extends React.Component<
  LoginContainerProps,
  LoginContainerState
> {
  public state: LoginContainerState = {
    isError: false,
    isShowingModal: false,
  };

  private handleSubmit = async (values: LoginFormValues) => {
    let newState: Partial<LoginContainerState>;

    try {
      // Perform request
      const { message, token }: any = await http.post(
        "auth/customers/login",
        values,
      );

      this.props.saveLoginToken(token);

      newState = {
        formMsg: message,
        isShowingModal: true,
      };
    } catch (error) {
      newState = {
        isError: true,
        formMsg: error.message,
      };
      if (error.errors) {
        // throw formatted error to redux-form
        throw new SubmissionError(error.errors);
      }
    } finally {
      this.setState(state => ({
        ...state,
        ...newState,
      }));
    }
  };

  private handleModalClose = () => {
    this.setState(state => ({ ...state, isShowingModal: false }));
    history.push("/"); // go to home page
  };

  public render() {
    return (
      <Wrapper>
        <MetaTags title="Đăng nhập" />,
        <Login handleSubmit={this.handleSubmit} {...this.state} />
        <AccountModal
          handleClose={this.handleModalClose}
          isOpen={this.state.isShowingModal}
        />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state: RootState): Partial<LoginContainerProps> => ({
  isLoggedIn: authSelectors.isLoggedIn(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<LoginContainerProps> => ({
  saveLoginToken: token => dispatch(authActions.saveToken(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);



// WEBPACK FOOTER //
// ./src/routes/Account/components/LoginContainer.tsx